<template>
  <DragDialog v-model:visible="visible" :title="dialogTitle" :defaultPosition="position">
    <template v-if="visible">
      <BasicInfoForm
        v-model="formData"
        disabled
        showTooltip
      />
      <TechnicalInfoForm
        v-model="formData"
        disabled
      />
    </template>
  </DragDialog>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import DragDialog from '@/components/dialogs/DragDialog.vue'
import BasicInfoForm from '@/components/form/BasicInfoForm.vue'
import TechnicalInfoForm from '@/components/form/TechnicalInfoForm.vue'

const visible = ref(false)
const dialogTitle = ref()
const formData = ref()
const position = ref({ top: 130, left: 30 })

const open = (title, data, index = 0) => {
  const padding = 30;

  visible.value = true
  dialogTitle.value = title
  formData.value = data
  position.value.left = padding + index * (window.innerWidth - (padding * 2)) / 4
}

const close = () => {
  visible.value = false
}

defineExpose({ open, close })
</script>

<style lang="scss" scoped>

</style>